module.exports = __webpack_public_path__ + "static/media/IMG_20190826_180805.image.f3622dd5.png";